import { render, staticRenderFns } from "./LeadFileModal.vue?vue&type=template&id=221d8a18&scoped=true&"
import script from "./LeadFileModal.vue?vue&type=script&lang=js&"
export * from "./LeadFileModal.vue?vue&type=script&lang=js&"
import style0 from "./LeadFileModal.vue?vue&type=style&index=0&id=221d8a18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221d8a18",
  null
  
)

export default component.exports